import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import "./Doorscanner";
// import logo from "../assets/img/logo-Photoroom.png";
import logo from "../assets/img/fireLogo.png";
import coblogo from "../assets/img/Assure Fire Final Logo-06.png";
import logpic from "../assets/img/Loginpic.png";
import footerLogo from "../assets/img/Assure Fire Final Logo-04.png";
// import styles from "../assets/css/styles.css";
import Toaster from "./common/Toaster";
import { clearUser, loginUser } from "../store/slices/UserSlice";
// import DoorScanner from "../doorscanner";
import http from "../api/server";
import {
  CHECK_EMAIL_API,
  CLIENT_ONBOARD_API,
  SENT_OTP_TO_CHECK_CLIENT,
  VALIDATE_OTP_NEW_CLIENT,
} from "../api/apiPath";

const LogIn = () => {
  const { clientNameParam } = useParams();
  const [step, setStep] = useState("checkEmail"); // checkEmail | resetPassword | login
  const [isNewUserRegistrationStart, setIsNewUserRegistrationStart] =
    useState(false);
  // const [strengthColor, setStrengthColor] = useState("black");
  const [email, setEmail] = useState("");
  const [isEmailExist, setIsEmailExist] = useState(true);
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [clientName, setClientName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [counter, setCounter] = useState(30);
  const inputRefs = useRef([]);
  const defaultOTPObj = {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };
  useEffect(() => {
    inputRefs.current[0]?.focus(); // Focus on the first input on component mount
  }, []);
  const [otpValues, setOtpValues] = useState(defaultOTPObj);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  // dispatch and navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   dispatch(
  //     logoutUser({
  //       userId: userObj?.userId,
  //       userIdentifier: userObj?.userEmail,
  //     })
  //   );
  // }, []);
  useEffect(() => {
    // Only clear local Redux state, don’t hit logout API again
    dispatch(clearUser());
  }, [dispatch]);
  // Simulated API call for checking if user exists
  const checkEmailAPI = async (email) => {
    try {
      const response = await http.post(CHECK_EMAIL_API, {
        email,
      });
      return response.data;
    } catch (error) {
      return false;
    }
  };
  useEffect(() => {
    let timer;
    if (isResendDisabled && step == "enter otp" && counter > 0) {
      timer = setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled, step]);
  // registerUser
  const registerClinet = async () => {
    setLoading(true);
    try {
      const response = await http.post(CLIENT_ONBOARD_API, {
        clientName,
        firstName,
        lastName,
        password,
        userEmail: email,
      });
      if (response?.data) {
        setIsNewUserRegistrationStart(false);
        setClientName("");
        setFirstName("");
        setLastName("");
        setPassword("");
        setConfirmPassword("");
        return response;
      }
    } catch (error) {
      if (error?.status === 404) {
        setStep("registerUser");
      } else {
        throw new Error(`HTTP error! status: ${error}`);
      }
    }
  };
  const handleResend = () => {
    // Trigger resend OTP logic here
    console.log("Resending OTP...");
    setCounter(30);
    setIsResendDisabled(true);
    setOtpValues(defaultOTPObj);
  };
  // Simulated API call for password reset
  // Real API call for password reset
  const resetPasswordAPI = async (email, password) => {
    try {
      const response = await http.post("/api/Auth/reset-password", {
        email,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };
  const handleUserRegister = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (password.length < 8) {
      setLoginError("Password must be at least 8 characters long!");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setLoginError("Passwords do not match!");
      setLoading(false);
      return;
    }
    const response = await sendOTPToVeifyClient();
    if (response.status !== 400) {
      setStep("enter otp client");
      setValidate({
        hasLow: false,
        hasCap: false,
        hasNumber: false,
        has8digit: false,
      });
    } else {
      setLoginError(response?.data?.message);
    }
    setLoading(false);
  };

  //RegisterUser
  const sendOTPToVeifyClient = async () => {
    try {
      const response = await http.post(SENT_OTP_TO_CHECK_CLIENT, {
        clientName: clientName,
        userEmail: email,
      });
      return response;
      // return response;
    } catch (error) {
      return error;
    }
  };

  const verifyOTP = async () => {
    const otpString = Object.values(otpValues).join("");
    try {
      const response = await http.post("/api/Auth/verify-otp", {
        email,
        otp: otpString,
        password,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  const validateOTPForNewClient = async () => {
    const otpString = Object.values(otpValues).join("");
    let resData = "";
    try {
      const response = await http.post(VALIDATE_OTP_NEW_CLIENT, {
        userEmail: email,
        otp: otpString,
      });
      if (response.status !== 400) {
        resData = registerClinet();
      }
      return resData;
    } catch (error) {
      return error;
    }
  };

  // const handleEmailSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoginError("");
  //   setLoading(true);
  //   const exists = await checkEmailAPI(email);

  //   if (exists) {
  //     // setStep('resetPassword');
  //     if (exists["passwordSet"]) {
  //       setStep("login");
  //     } else {
  //       setStep("change password");
  //     }
  //   } else {
  //     setIsEmailExist(false);
  //     // navigate("/signin")
  //     // setStep("not found");
  //   }
  //   setLoginError("");
  //   setLoading(false);
  // };
  //
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoading(true);

    try {
      const response = await checkEmailAPI(email);

      if (response) {
        const userExist = response?.exists;
        const setPass = response?.passwordSet;
        const isActive = response?.isActive;

        if (userExist && setPass && isActive) {
          setStep("login");
        } else if (!isActive) {
          setLoginError("Your account is inactive.");
        } else if (userExist && !setPass) {
          setStep("change password");
        } else {
          setIsEmailExist(false);
        }
      } else {
        setIsEmailExist(false);
      }
    } catch (err) {
      setLoginError("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  const handleVerifyOTP = async (e) => {
    setLoading(true);
    e.preventDefault();
    setLoginError("");

    if(isNewUserRegistrationStart){
      const response = await validateOTPForNewClient();
    if (
      response?.data?.message == "Invalid OTP." ||
      response?.data?.message == "OTP is expired. Please re-generate OTP." ||
      response?.data?.message == "OTP is already used. Please re-generate OTP."
    ) {
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: response?.data?.message,
      });
      setOtpValues(defaultOTPObj);
      setLoginError(response?.data?.message);
      setStep("enter otp client");
    } else {
      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: response?.data?.message,
      });
      resetValue();
      setStep("login");
    }
    setLoading(false);
    }else {
      const response = await verifyOTP();
    if (
      response?.data?.message == "Invalid OTP." ||
      response?.data?.message == "OTP is expired. Please re-generate OTP." ||
      response?.data?.message == "OTP is already used. Please re-generate OTP."
    ) {
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: response?.data?.message,
      });
      setOtpValues(defaultOTPObj);
      setLoginError(response?.data?.message);
      setStep("enter otp");
    } else {
      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: response?.data?.message,
      });
      resetValue();
      setStep("login");
    }
    setLoading(false);
    }

    
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoginError("");
    if (password.length < 8) {
      setLoginError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setLoginError("Passwords do not match.");
      return;
    }
    const response = await resetPasswordAPI(email, password);
    if (response.status !== 400) {
      //resetValue();
      setStep("enter otp");
    } else {
      setLoginError(response?.response?.data?.message);
      //setConfirmPassword("");
      //setPassword("");
      // setStep("login");
    }
    setLoading(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLoginError(null);
    dispatch(
      loginUser({ email, password, application: "Assure Fire AI" })
    ).then((res) => {
      setLoading(false);
      if (res?.payload !== undefined) {
        // localStorage.setItem('token', res?.payload?.token);
        setEmail("");
        setPassword("");
        if(clientNameParam){
          navigate(
            generatePath("/client/:clientNameParam/property-form", {
              clientNameParam,
            })
          );
        } else {
            // Fallback if login happened on "/" or "/client" (no :clientName in URL).
            // Choose the right destination for your app. For now, send them to "/client".
            navigate("/client");
            setStep("checkEmail");
          }
      } else {
        if (res?.error?.message === "Request failed with status code 401") {
          setLoginError("Access Denied! Invalid password");
        } else {
          setLoginError(res?.error?.message);
        }
      }
    });
  };
  const [validate, setValidate] = useState({
    hasLow: false,
    hasCap: false,
    hasNumber: false,
    has8digit: false,
  });
  const strengthNew = Object.values(validate).reduce((a, item) => a + item, 0);
  const validatePassword = (password) => {
    if (password.match(/\d+/g)) {
      setValidate((o) => ({ ...o, hasNumber: true }));
    } else {
      setValidate((o) => ({ ...o, hasNumber: false }));
    }

    if (password.match(/[A-Z]+/g)) {
      setValidate((o) => ({ ...o, hasCap: true }));
    } else {
      setValidate((o) => ({ ...o, hasCap: false }));
    }

    if (password.match(/[a-z]+/g)) {
      setValidate((o) => ({ ...o, hasLow: true }));
    } else {
      setValidate((o) => ({ ...o, hasLow: false }));
    }

    if (password.length > 7) {
      setValidate((o) => ({ ...o, has8digit: true }));
    } else {
      setValidate((o) => ({ ...o, has8digit: false }));
    }
  };
  const feedback = {
    1: "Password is too weak!",
    2: "It's still weak! ",
    3: "You almost there!",
    4: "Great!! now your password is strong",
  }[strengthNew];

  const strongText = "Great!! now your password is strong";
  const [enableCountniue, setEnableCountniue] = useState(true);

  useEffect(() => {
    if (!password && !confirmPassword) return;
    if (
      password.length > 7 &&
      confirmPassword.length > 7 &&
      password.length === confirmPassword.length &&
      password === confirmPassword &&
      feedback === strongText
    ) {
      setEnableCountniue(false);
    } else {
      setEnableCountniue(true);
    }
  }, [password, confirmPassword, feedback]);

  const handlePassword = (value) => {
    setLoginError("");
    setPassword(value);
    validatePassword(value);
  };
  const handleEmail = (e) => {
    setLoginError("");
    setIsEmailExist(true);
    setEmail(e.target.value);
  };
  const resetValue = () => {
    setConfirmPassword("");
    setLoading(false);
    setPassword("");
    // setEmail("");
    setLoginError("");
    setIsEmailExist(true);
    setValidate({
      hasLow: false,
      hasCap: false,
      hasNumber: false,
      has8digit: false,
    });
    setOtpValues(defaultOTPObj);
  };

  const setOTPValue = (value, digitKey, index) => {
    setOtpValues((prevOtpValues) => ({
      ...prevOtpValues,
      [digitKey]: value.substring(value.length - 1), // Take only the last character entered
    }));
    // Auto-focus the next input field if a digit is entered and it's not the last field
    if (value.length === 1 && index !== 5) {
      inputRefs.current[index + 1].focus();
    }
  };
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
    setOtpValues(defaultOTPObj);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordMain, setShowPasswordMain] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const mainScreenShowPass = () => {
    setShowPasswordMain((prev) => !prev);
  };
  const resetScreenShowPass = () => {
    setShowPassword((prev) => !prev);
  };

  const confirmShowPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const optArray = pastedData.split("");

      const defaultOTPObj = {
        digit1: optArray[0],
        digit2: optArray[1],
        digit3: optArray[2],
        digit4: optArray[3],
        digit5: optArray[4],
        digit6: optArray[5],
      };

      setOtpValues(defaultOTPObj);
      // Optionally focus the last input after pasting
      inputRefs.current[5]?.focus();
    }
  };
  const handleFirstName = (e) => {
    setFirstName(e.target.value);
  };
  return (
    <div className="main_body">
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
      {step === "registerUser" && (
        <div className="login-page d-flex">
          {/* Left Side (Form) */}
          <div className="login-form-section d-flex flex-column justify-content-center align-items-center">
            <div className="login-form-wrapper">
              <div className="text-center personalName ">
                <img src={coblogo} alt="logo" className="login-logo" />
                <p style={{ fontSize: "12px", marginTop: "10px" }}>
                  Client Onboarding
                </p>
              </div>

              {/*  Register Form */}
              <form
                className="px-4 py-4 register-form "
                onSubmit={handleUserRegister}
              >
                {/* Row 1 */}
                <div className="row mb-2">
                  <div className="col-md-6 mb-4">
                    <div className="">
                      <label className="form-label personalName">
                        Client Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter client name"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-6">
                    <div>
                      <label className="form-label personalName">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={handleFirstName}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-6">
                    <div className="mb-3">
                      <label className="form-label personalName">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label personalName">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        value={email}
                        onChange={handleEmail}
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Row 3 */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="mb-3 position-relative">
                      <label className="form-label personalName">
                        Password
                      </label>
                      <input
                        type={showPasswordMain ? "text" : "password"}
                        className="form-control password-input"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => handlePassword(e.target.value)}
                        required
                      />
                      <i
                        className={`fa-solid ${
                          showPasswordMain ? "fa-eye-slash" : "fa-eye"
                        } fa-sm showAndHidePass password-toggle`}
                        style={{ marginTop: "-20px" }}
                        onClick={mainScreenShowPass}
                      ></i>
                      {password.length > 0 && (
                        <>
                          <progress
                            className={`password strength-${strengthNew}`}
                            value={strengthNew}
                            max="4"
                          />
                          <div className={`feedback strength-${strengthNew}`}>
                            {feedback}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3 position-relative">
                      <label className="form-label personalName">
                        Re-enter Password
                      </label>
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control password-input"
                        placeholder="Re-enter password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <i
                        className={`fa-solid ${
                          showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                        } fa-sm showAndHidePass password-toggle`}
                        style={{ marginTop: "-20px" }}
                        onClick={confirmShowPassword}
                      ></i>

                      <div className={`feedback strength-1`}>{loginError}</div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-continue personalName w-100"
                      onClick={handleUserRegister}
                      disabled={loading || email.length === 0}
                    >
                      {loading ? "Please Wait..." : "Continue"}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <p className="footertext personalName">
              By continuing, you agree to our Terms of Service and Privacy
              Policy
            </p>
          </div>

          {/* Right Side (Image) */}
          <div className="login-image-section">
            <img
              src={logpic}
              alt="login-illustration"
              className="login-side-image"
            />
          </div>
        </div>
      )}

      {step === "checkEmail" && (
        <div className="containers d-flex align-items-center py-2 main_header justify-content-center login_card">
          <div className="card login-card d-flex align-items-center justify-content-center my-4 gap-3 p-5">
            <div className="text-center d-flex align-items-center gap-2 flex-column">
              <img src={logo} className="login-page-logo mb-2" alt="logo" />
              <h6 className="mb-2 white-text">Welcome to</h6>
              <h4 className="mb-2 fw-bold white-text">Fire Inspect AI</h4>
              <p className="text mb-2">Enter your email address to continue</p>
            </div>
            <div className="d-flex flex-column align-items-center gap-2">
              <form className="px-4" onSubmit={handleEmailSubmit}>
                <>
                  {!isEmailExist && (
                    <div className="text-danger mb-4">
                      User does not exist, please check the Email
                    </div>
                  )}
                </>
                <div className="col-sm-12 mb-3">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-controlinputbox"
                      id="floatingInput"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => handleEmail(e)}
                      required
                    />
                    {/* <label htmlFor="floatingInput">Email address</label> */}
                  </div>
                </div>

                <div className="col-sm-12">
                  <button
                    type="submit"
                    className="btn btn-secondarylog mb-3 w-100"
                  >
                    {loading ? "Please Wait..." : "Sign In"}
                  </button>
                </div>
                <div className="col-sm-12 mb-3 text-center d-flex justify-content-sm-center flex-column gap-3 flex-sm-row">
                  {/* <a href="#">Reset your password</a> */}
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setStep("registerUser");
                      setClientName("");
                      setFirstName("");
                      setLastName("");
                      setPassword("");
                      setConfirmPassword("");
                      setIsNewUserRegistrationStart(true);
                    }}
                    style={{
                      color: "white",
                      backgroundColor: " #0c1b39",
                    }}
                  >
                    Register New Client
                  </button>
                </div>

                <>
                  {loginError && (
                    <div className="text-danger">{loginError}</div>
                  )}
                </>

                {/* <div className="col-sm-12 mb-4 text-center">
                  <Link to="/signin">Get help signing in</Link>
                </div> */}
              </form>
              <div className="terms-conditions">
                <p>
                  By continuing, you agree to our Terms of Service and Privacy
                  Policy
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === "enter otp client" && (
        <>
          <div className="login-page">
            <div className="login-form-section d-flex flex-column justify-content-center align-items-center">
              <div className="login-form-wrapper">
                <img src={coblogo} alt="logo" className="login-logo" />
                {/* <h2 className="mb-0 fw-bold gradient-text">Assure Fire</h2> */}
              </div>
              <div className="card-body px-5 py-3">
                <div className="col-sm-12">
                  <p className=" personalName ">Client Onboarding</p>
                </div>
                <div className="col-sm-12">
                  <p
                    className="mes personalName "
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Enter the 6-digit code sent to
                  </p>
                  <p
                    className="mes personalName "
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    <strong
                      style={{
                        marginLeft: "5px",
                        color: "#FFA500",
                        fontSize: "14px",
                      }}
                    >
                      {email}
                    </strong>
                  </p>
                </div>
                <div className="form-floating my-4 d-flex gap-3">
                  <input
                    type="text"
                    className="form-control-box1"
                    maxLength="1"
                    value={otpValues.digit1}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit1", 0);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                    ref={(el) => (inputRefs.current[0] = el)}
                    onPaste={handlePaste}
                  />
                  <input
                    type="text"
                    className="form-control-box2"
                    maxLength="1"
                    value={otpValues.digit2}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit2", 1);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                    ref={(el) => (inputRefs.current[1] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box3"
                    maxLength="1"
                    value={otpValues.digit3}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit3", 2);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 2)}
                    ref={(el) => (inputRefs.current[2] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box4"
                    maxLength="1"
                    value={otpValues.digit4}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit4", 3);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 3)}
                    ref={(el) => (inputRefs.current[3] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box5"
                    maxLength="1"
                    value={otpValues.digit5}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit5", 4);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 4)}
                    ref={(el) => (inputRefs.current[4] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box6"
                    maxLength="1"
                    value={otpValues.digit6}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit6", 5);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 5)}
                    ref={(el) => (inputRefs.current[5] = el)}
                  />
                </div>

                {/* <div className="row my-3"> */}
                {/* <div className="col-12 col-sm-6 col-lg-6">
                    <button
                      type="submit"
                      className="btn btn-secondary mb-3 w-100"
                      onClick={() => {
                        setStep("checkEmail");
                        resetValue();
                      }}
                    >
                      Cancel
                    </button>
                  </div> */}
                <div className="row justify-content-center">
                  <div className="col-12 col-sm-6 col-lg-4 text-center">
                    <p
                      style={{ width: "150px", marginLeft: "-20px !important" }}
                    >
                      <span
                        onClick={isResendDisabled ? null : handleResend}
                        className="resend"
                        style={{
                          cursor: isResendDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        {isResendDisabled
                          ? `Resend OTP in ${counter}s`
                          : "Resend OTP"}
                      </span>
                    </p>
                    <button
                      type="submit"
                      className="verifyotp personalName mt-5 "
                      onClick={(e) => handleVerifyOTP(e)}
                      disabled={
                        loading ||
                        Object.values(otpValues).some((digit) => digit === "")
                      }
                    >
                      {loading ? "Please Wait..." : "Verify OTP"}
                    </button>
                  </div>
                </div>

                {/* </div> */}
                <div className="col-12 d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btnresend mb-3 w-100"
                    style={{
                      textDecoration: "underline",
                      textUnderlinePosition: "under",
                    }}
                    onClick={() => {
                      setStep("checkEmail");
                      setEmail("");
                      resetValue();
                    }}
                  >
                    <i className="fa fa-arrow-left mt-5 me-2"></i> Back to Login
                  </button>
                </div>
                <p className="footertextotp personalName">
                  By continuing, you agree to our Terms of Service and Privacy
                  Policy
                </p>
              </div>
            </div>
            <div className="login-image-section">
              <img
                src={logpic}
                alt="login-illustration"
                className="login-side-image"
              />
            </div>
          </div>
        </>
      )}
      {step === "enter otp" && (
        <>
          <div className="containers d-flex align-items-center py-2 main_header justify-content-center login_card">
            <div className="card login-card d-flex align-items-center justify-content-center my-4 gap-3 p-5">
              <div className="text-center d-flex align-items-center gap-2 flex-column">
                <img src={logo} className="login-page-logo mb-2" alt="logo" />
                <h6 className="mb-2 white-text">Welcome to</h6>
                <h4 className="mb-2 fw-bold white-text">Fire Inspect AI</h4>
                <p className="text mb-2">
                  Enter the 6-digit code sent to{" "}
                  <strong
                    style={{
                      marginLeft: "5px",
                      color: "#FFA500",
                      fontSize: "14px",
                    }}
                  >
                    {email}
                  </strong>
                </p>
              </div>
              <div className="d-flex flex-column align-items-center gap-2">
                <div className="col-sm-12 mb-3 d-flex gap-3">
                  <input
                    type="text"
                    className="form-control-box1"
                    maxLength="1"
                    value={otpValues.digit1}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit1", 0);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                    ref={(el) => (inputRefs.current[0] = el)}
                    onPaste={handlePaste}
                  />
                  <input
                    type="text"
                    className="form-control-box2"
                    maxLength="1"
                    value={otpValues.digit2}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit2", 1);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                    ref={(el) => (inputRefs.current[1] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box3"
                    maxLength="1"
                    value={otpValues.digit3}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit3", 2);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 2)}
                    ref={(el) => (inputRefs.current[2] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box4"
                    maxLength="1"
                    value={otpValues.digit4}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit4", 3);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 3)}
                    ref={(el) => (inputRefs.current[3] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box5"
                    maxLength="1"
                    value={otpValues.digit5}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit5", 4);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 4)}
                    ref={(el) => (inputRefs.current[4] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box6"
                    maxLength="1"
                    value={otpValues.digit6}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit6", 5);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 5)}
                    ref={(el) => (inputRefs.current[5] = el)}
                  />
                </div>
                <div className="col-sm-12 text-center">
                  <p
                  // style={{ width: "150px", marginLeft: "-20px !important" }}
                  >
                    <span
                      onClick={isResendDisabled ? null : handleResend}
                      className="resend"
                      style={{
                        cursor: isResendDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      {isResendDisabled
                        ? `Resend OTP in ${counter}s`
                        : "Resend OTP"}
                    </span>
                  </p>
                  <button
                    type="submit"
                    className="btn btn-secondarylog mb-3 w-100"
                    onClick={(e) => handleVerifyOTP(e)}
                    disabled={
                      loading ||
                      Object.values(otpValues).some((digit) => digit === "")
                    }
                  >
                    {loading ? "Please Wait..." : "Verify OTP"}
                  </button>
                </div>

                <div className="col-sm-12 d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btnresend mb-3 w-100"
                    style={{
                      textDecoration: "underline",
                      textUnderlinePosition: "under",
                    }}
                    onClick={() => {
                      setStep("checkEmail");
                      setEmail("");
                      resetValue();
                    }}
                  >
                    <i className="fa fa-arrow-left mt-5 me-2"></i> Back to Login
                  </button>
                </div>

                <div className="terms-conditions">
                  <p>
                    By continuing, you agree to our Terms of Service and Privacy
                    Policy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {step === "reset password" && (
        <div className="containers d-flex align-items-center py-2 main_header justify-content-center login_card">
          <div className="card login-card d-flex align-items-center justify-content-center my-4 gap-3 p-5">
            <div className="text-center d-flex align-items-center gap-2 flex-column">
              <img src={logo} className="login-page-logo mb-2" alt="logo" />
              <h6 className="mb-2 white-text">Welcome to</h6>
              <h4 className="mb-2 fw-bold white-text">Fire Inspect AI</h4>
              <p className="text mb-2">Enter your email address</p>
              <p className="text mb-2">
                To reset your password, please enter your <br></br> email
                address you may have used with Acache.
              </p>
            </div>
            <div className="d-flex flex-column align-items-center gap-2 px-4">
              <div className="col-sm-12 mb-2">
                <input
                  type="email"
                  className="form-controlinputbox w-100"
                  id="floatingInput"
                  onChange={(e) => handleEmail(e)}
                  placeholder="Enter your email address"
                />
              </div>

              <div className="col-sm-12 mb-3">
                <button
                  type="submit"
                  className="btn btn-secondarylog mb-3 w-100"
                  onClick={() => {
                    setStep("change password");
                    setOtpValues(defaultOTPObj);
                  }}
                >
                  {loading ? "Please Wait..." : "Continue"}
                </button>
              </div>
              {/* <div className="col-sm-12 mb-4 text-center">
                <a href="getHelp.html">Get help signing in</a>
              </div> */}
              <div className="terms-conditions ">
                <p>
                  By continuing, you agree to our Terms of Service and Privacy
                  Policy
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === "change password" && (
        <div className="containers d-flex align-items-center py-2 main_header justify-content-center login_card">
          <div className="card login-card d-flex align-items-center justify-content-center my-4 gap-3 p-5">
            <div className="text-center d-flex align-items-center gap-2 flex-column">
              <img src={logo} className="login-page-logo mb-2" alt="logo" />
              <h6 className="mb-2 white-text">Welcome to</h6>
              <h4 className="mb-2 fw-bold white-text">Fire Inspect AI</h4>
              <p className="text mb-2">Enter new password</p>
            </div>
            <div className="d-flex flex-column align-items-center gap-2">
              <form className="px-4" onSubmit={handleResetPassword}>
                <div className="col-sm-12 mb-2">
                  <div
                    className="form-floating"
                    // style={{ position: "relative" }}
                  >
                    <input
                      className="form-controlinputbox pe-5"
                      id="passwordInput"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your new password"
                      value={password}
                      onChange={(e) => handlePassword(e.target.value)}
                      required
                    />
                    <i
                      className={`fa-solid mt-4 ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      } fa-sm showAndHidePass`}
                      onClick={resetScreenShowPass}
                    ></i>
                    <div>
                      {strengthNew > 0 ? (
                        <progress
                          hidden={password.length === 0}
                          className={`password strength-${strengthNew}`}
                          value={strengthNew}
                          max="4"
                        />
                      ) : null}
                    </div>
                    <div
                      className={`feedback strength-${strengthNew}`}
                      hidden={password.length === 0}
                    >
                      {feedback}
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <div
                    className="form-floating"
                    // style={{ position: "relative" }}
                  >
                    <input
                      className="form-controlinputbox pe-5"
                      id="floatingInput"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm New Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <i
                      className={`fa-solid mt-4 ${
                        showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                      } fa-sm  showAndHidePass`}
                      onClick={confirmShowPassword}
                    ></i>
                  </div>
                </div>
                <>
                  {loginError ||
                    (true && <div className="text-danger">{loginError}</div>)}
                </>
                <div className="col-sm-12 mb-2 ">
                  <button
                    type="submit"
                    className="btn btn-secondarylog mb-3 w-100"
                    disabled={enableCountniue}
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
                <div className="col-sm-12 mb-3 text-center d-flex justify-content-sm-center flex-column gap-3 flex-sm-row">
                  {/* <a href="#">Reset your password</a> */}
                  <button
                    className="buttonStyle"
                    style={{
                          color: "white",
                          backgroundColor: " #0c1b39",
                        }}  
                    onClick={() => {
                      setEmail("");
                      resetValue();
                      setStep("checkEmail");
                    }}
                  >
                    Sign in to a different account
                  </button>
                </div>
              </form>
              <div className="terms-conditions pt-2">
                <p className="mb-0">
                  By continuing, you agree to our Terms of Service and Privacy
                  Policy
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {step === "login" && (
        <div className="containers d-flex align-items-center py-2 main_header justify-content-center login_card">
          <div className="card login-card d-flex align-items-center justify-content-center my-4 gap-3 p-5">
            <div className="text-center d-flex align-items-center gap-2 flex-column">
              <img src={logo} className="login-page-logo mb-2" alt="logo" />
              <h6 className="mb-2 white-text">Welcome to</h6>
              <h4 className="mb-2 fw-bold white-text">Fire Inspect AI</h4>
              <p className="text mb-2">Enter your password to continue</p>
            </div>
            <div className="card-body">
              <form className="px-4" onSubmit={handleLogin}>
                <div
                  className="mb-3 px-3 form-controlinputbox"
                  style={{ marginLeft: "5px" }}
                >
                  <div className="d-flex gap-3  justify-content-center">
                    {/* <FontAwesomeIcon icon={faUserShield} /> */}

                    <p className="fs-6 mb-0 fw-semibold">{email}</p>
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <div className="form-floating">
                    <input
                      className="form-controlinputbox pe-5"
                      id="passwordInput"
                      type={showPasswordMain ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => handlePassword(e.target.value)}
                      required
                    />
                    {/* <label htmlFor="passwordInput">Password</label> */}
                    <i
                      className={`fa-solid mt-4  ${
                        showPasswordMain ? "fa-eye-slash" : "fa-eye"
                      } fa-sm  showAndHidePass`}
                      onClick={mainScreenShowPass}
                    ></i>
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <button type="submit" className="btn btn-secondarylog  w-100">
                    {loading ? "Please Wait..." : "Sign In"}
                  </button>
                </div>
                <>
                  {loginError && (
                    <div className="text-danger ">{loginError}</div>
                  )}
                </>

                <div className="col-sm-12 mb-2  text-center d-flex justify-content-sm-between flex-column gap-3 flex-sm-row">
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      resetValue();
                      setStep("reset password");
                    }}
                    style={{
                      color: "white",
                      backgroundColor: "#0c1b39",
                    }}
                  >
                    Reset your password
                  </button>
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setEmail("");
                      resetValue();
                      setStep("checkEmail");
                    }}
                    style={{
                      color: "white",
                      backgroundColor: " #0c1b39",
                    }}
                  >
                    Sign in to a different account
                  </button>
                </div>
              </form>
              <div className="terms-conditions pt-2">
                <p className="mb-0">
                  By continuing, you agree to our Terms of Service and Privacy
                  Policy
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <DoorScanner/> */}
      {/* <img
        src={require("../assets/img/acachelogo.png")}
        alt="Acache Logo"
        className="bottom-right-logo"
      /> */}
      <div className="footer-fixed">
        <p className="footertext mb-0">Powered By</p>
        <img
          src={footerLogo}
          alt="Acache Logo"
          className="bottom-right-logo-down"
        />
      </div>
    </div>
  );
};

export default LogIn;
